module.exports = __webpack_public_path__ + "8b3424f981ad0e3ec480544cdbebff7a.svg";